import { appRoutes } from "../../../constants/appRoutes";

export const resolutionsRoute = {
    path: appRoutes.resolutions.path,
    lazy: () => import('../../../pages/Resolutions'),
}